module.exports = __webpack_public_path__ + "assets/img/busy_1.0c128847.png";